export const BorderS = 1;
export const BorderM = 2;
export const BorderL = 3;
export const ColorPrimary01100 = "#eaf3e2";
export const ColorPrimary01200 = "#cbe3b5";
export const ColorPrimary01300 = "#add585";
export const ColorPrimary01400 = "#91c854";
export const ColorPrimary01500 = "#78be20";
export const ColorPrimary01600 = "#41a017";
export const ColorPrimary01700 = "#158110";
export const ColorPrimary01800 = "#0a601b";
export const ColorPrimary01900 = "#053e1f";
export const ColorPrimary02100 = "#dbedea";
export const ColorPrimary02200 = "#a5d1cb";
export const ColorPrimary02300 = "#6eb4ad";
export const ColorPrimary02400 = "#379590";
export const ColorPrimary02500 = "#007574";
export const ColorPrimary02600 = "#035f64";
export const ColorPrimary02700 = "#044c53";
export const ColorPrimary02800 = "#063a44";
export const ColorPrimary02900 = "#062b35";
export const ColorGrey100 = "#eeeef0";
export const ColorGrey200 = "#d3d2d6";
export const ColorGrey300 = "#bab6bc";
export const ColorGrey400 = "#a19ba2";
export const ColorGrey500 = "#887f87";
export const ColorGrey600 = "#6f676c";
export const ColorGrey700 = "#554f52";
export const ColorGrey800 = "#3c3738";
export const ColorGrey900 = "#222020";
export const ColorGrey999 = "#000000";
export const ColorGrey000 = "#ffffff";
export const ColorSecondaryBlue100 = "#ecfcfd";
export const ColorSecondaryBlue200 = "#b7eef5";
export const ColorSecondaryBlue300 = "#84dbeb";
export const ColorSecondaryBlue400 = "#54c4de";
export const ColorSecondaryBlue500 = "#25a8d0";
export const ColorSecondaryBlue600 = "#2282a8";
export const ColorSecondaryBlue700 = "#1e5f82";
export const ColorSecondaryBlue800 = "#18415d";
export const ColorSecondaryBlue900 = "#102739";
export const ColorSecondaryGreen100 = "#eaf3e2";
export const ColorSecondaryGreen200 = "#cbe3b5";
export const ColorSecondaryGreen300 = "#add585";
export const ColorSecondaryGreen400 = "#91c854";
export const ColorSecondaryGreen500 = "#78be20";
export const ColorSecondaryGreen600 = "#41a017";
export const ColorSecondaryGreen700 = "#158110";
export const ColorSecondaryGreen800 = "#0a601b";
export const ColorSecondaryGreen900 = "#053e1f";
export const ColorSecondaryPurple100 = "#efebfe";
export const ColorSecondaryPurple200 = "#c7b0fa";
export const ColorSecondaryPurple300 = "#a575f3";
export const ColorSecondaryPurple400 = "#883be9";
export const ColorSecondaryPurple500 = "#7000dd";
export const ColorSecondaryPurple600 = "#5803b3";
export const ColorSecondaryPurple700 = "#42058a";
export const ColorSecondaryPurple800 = "#2e0663";
export const ColorSecondaryPurple900 = "#1c053d";
export const ColorSecondaryRed100 = "#feedee";
export const ColorSecondaryRed200 = "#fab9bc";
export const ColorSecondaryRed300 = "#f38789";
export const ColorSecondaryRed400 = "#ea5d58";
export const ColorSecondaryRed500 = "#df382b";
export const ColorSecondaryRed600 = "#b42a27";
export const ColorSecondaryRed700 = "#8b2226";
export const ColorSecondaryRed800 = "#641b21";
export const ColorSecondaryRed900 = "#3e1219";
export const ColorSecondaryOrange100 = "#fff5eb";
export const ColorSecondaryOrange200 = "#ffdab2";
export const ColorSecondaryOrange300 = "#ffc17d";
export const ColorSecondaryOrange400 = "#ffab4b";
export const ColorSecondaryOrange500 = "#fc961e";
export const ColorSecondaryOrange600 = "#c86f21";
export const ColorSecondaryOrange700 = "#974f20";
export const ColorSecondaryOrange800 = "#6a351c";
export const ColorSecondaryOrange900 = "#401f15";
export const ColorSecondaryYellow100 = "#fff8e2";
export const ColorSecondaryYellow200 = "#ffebaf";
export const ColorSecondaryYellow300 = "#fee07d";
export const ColorSecondaryYellow400 = "#fcd64c";
export const ColorSecondaryYellow500 = "#f8cc1c";
export const ColorSecondaryYellow600 = "#c9a21b";
export const ColorSecondaryYellow700 = "#9c7b18";
export const ColorSecondaryYellow800 = "#705613";
export const ColorSecondaryYellow900 = "#46350d";
export const ColorDanger100 = "#feedee";
export const ColorDanger200 = "#fab9bc";
export const ColorDanger300 = "#f38789";
export const ColorDanger400 = "#ea5d58";
export const ColorDanger500 = "#df382b";
export const ColorDanger600 = "#b42a27";
export const ColorDanger700 = "#8b2226";
export const ColorDanger800 = "#641b21";
export const ColorDanger900 = "#3e1219";
export const ColorInfo100 = "#ecfcfd";
export const ColorInfo200 = "#b7eef5";
export const ColorInfo300 = "#84dbeb";
export const ColorInfo400 = "#54c4de";
export const ColorInfo500 = "#25a8d0";
export const ColorInfo600 = "#2282a8";
export const ColorInfo700 = "#1e5f82";
export const ColorInfo800 = "#18415d";
export const ColorInfo900 = "#102739";
export const ColorWarning100 = "#fff5eb";
export const ColorWarning200 = "#ffdab2";
export const ColorWarning300 = "#ffc17d";
export const ColorWarning400 = "#ffab4b";
export const ColorWarning500 = "#fc961e";
export const ColorWarning600 = "#c86f21";
export const ColorWarning700 = "#974f20";
export const ColorWarning800 = "#6a351c";
export const ColorWarning900 = "#401f15";
export const ColorSuccess100 = "#eaf3e2";
export const ColorSuccess200 = "#cbe3b5";
export const ColorSuccess300 = "#add585";
export const ColorSuccess400 = "#91c854";
export const ColorSuccess500 = "#78be20";
export const ColorSuccess600 = "#41a017";
export const ColorSuccess700 = "#158110";
export const ColorSuccess800 = "#0a601b";
export const ColorSuccess900 = "#053e1f";
export const ColorButtonSolidBackground = "#78be20";
export const ColorButtonSolidFont = "#ffffff";
export const ColorButtonSolidFocusBorder = "#158110";
export const ColorButtonSolidDisabledBackground = "#d3d2d6";
export const ColorButtonSolidDisabledFont = "#6f676c";
export const ColorButtonSolidActiveBackground = "#158110";
export const ColorButtonSolidHoverBackground = "#41a017";
export const ColorButtonSolidHoverFont = "#ffffff";
export const ColorButtonSolidPrimary02Background = "#007574";
export const ColorButtonSolidPrimary02Font = "#ffffff";
export const ColorButtonSolidPrimary02FocusBorder = "#062b35";
export const ColorButtonSolidPrimary02DisabledBackground = "#d3d2d6";
export const ColorButtonSolidPrimary02DisabledFont = "#6f676c";
export const ColorButtonSolidPrimary02ActiveBackground = "#062b35";
export const ColorButtonSolidPrimary02HoverBackground = "#063a44";
export const ColorButtonSolidPrimary02HoverFont = "#ffffff";
export const ColorButtonSolidNeutralBackground = "#887f87";
export const ColorButtonSolidNeutralFont = "#ffffff";
export const ColorButtonSolidNeutralFocusBorder = "#222020";
export const ColorButtonSolidNeutralDisabledBackground = "#d3d2d6";
export const ColorButtonSolidNeutralDisabledFont = "#6f676c";
export const ColorButtonSolidNeutralActiveBackground = "#3c3738";
export const ColorButtonSolidNeutralHoverBackground = "#554f52";
export const ColorButtonSolidNeutralHoverFont = "#ffffff";
export const ColorButtonSolidDangerBackground = "#df382b";
export const ColorButtonSolidDangerFont = "#ffffff";
export const ColorButtonSolidDangerFocusBorder = "#8b2226";
export const ColorButtonSolidDangerDisabledBackground = "#d3d2d6";
export const ColorButtonSolidDangerDisabledFont = "#6f676c";
export const ColorButtonSolidDangerActiveBackground = "#8b2226";
export const ColorButtonSolidDangerHoverBackground = "#b42a27";
export const ColorButtonSolidDangerHoverFont = "#ffffff";
export const ColorButtonBorderedBackground = "#ffffff";
export const ColorButtonBorderedBorder = "#78be20";
export const ColorButtonBorderedFont = "#78be20";
export const ColorButtonBorderedFocusBorder = "#158110";
export const ColorButtonBorderedDisabledBackground = "#d3d2d6";
export const ColorButtonBorderedDisabledFont = "#6f676c";
export const ColorButtonBorderedActiveBackground = "#cbe3b5";
export const ColorButtonBorderedHoverBackground = "#eaf3e2";
export const ColorButtonBorderedPrimary02Background = "#ffffff";
export const ColorButtonBorderedPrimary02Border = "#007574";
export const ColorButtonBorderedPrimary02Font = "#007574";
export const ColorButtonBorderedPrimary02FocusBorder = "#062b35";
export const ColorButtonBorderedPrimary02DisabledBackground = "#d3d2d6";
export const ColorButtonBorderedPrimary02DisabledFont = "#6f676c";
export const ColorButtonBorderedPrimary02ActiveBackground = "#a5d1cb";
export const ColorButtonBorderedPrimary02HoverBackground = "#dbedea";
export const ColorButtonBorderedNeutralBackground = "#ffffff";
export const ColorButtonBorderedNeutralBorder = "#887f87";
export const ColorButtonBorderedNeutralFont = "#887f87";
export const ColorButtonBorderedNeutralFocusBorder = "#222020";
export const ColorButtonBorderedNeutralDisabledBackground = "#d3d2d6";
export const ColorButtonBorderedNeutralDisabledFont = "#6f676c";
export const ColorButtonBorderedNeutralActiveBackground = "#d3d2d6";
export const ColorButtonBorderedNeutralHoverBackground = "#eeeef0";
export const ColorButtonBorderedDangerBackground = "#ffffff";
export const ColorButtonBorderedDangerBorder = "#df382b";
export const ColorButtonBorderedDangerFont = "#df382b";
export const ColorButtonBorderedDangerFocusBorder = "#8b2226";
export const ColorButtonBorderedDangerDisabledBackground = "#d3d2d6";
export const ColorButtonBorderedDangerDisabledFont = "#6f676c";
export const ColorButtonBorderedDangerActiveBackground = "#fab9bc";
export const ColorButtonBorderedDangerHoverBackground = "#feedee";
export const ColorDividerLightest = "#ffffff";
export const ColorDividerLight = "#bab6bc";
export const ColorDividerDefault = "#6f676c";
export const ColorDividerDark = "#000000";
export const ColorFieldsError = "#b42a27";
export const ColorFieldsLabel = "#3c3738";
export const ColorFieldsRequirement = "#6f676c";
export const ColorFieldsHelp = "#6f676c";
export const ColorFileuploaderFont = "#000000";
export const ColorFileuploaderFilesList = "#eeeef0";
export const ColorFileuploaderFilesDelete = "#d3d2d6";
export const ColorFileuploaderValid = "#78be20";
export const ColorFileuploaderAlert = "#b42a27";
export const ColorFlagSolidBackground = "#78be20";
export const ColorFlagSolidBorder = "#78be20";
export const ColorFlagSolidText = "#ffffff";
export const ColorFlagSolidPrimary02Background = "#035f64";
export const ColorFlagSolidPrimary02Border = "#035f64";
export const ColorFlagSolidPrimary02Text = "#ffffff";
export const ColorFlagSolidDarkBackground = "#000000";
export const ColorFlagSolidDarkBorder = "#000000";
export const ColorFlagSolidDarkText = "#ffffff";
export const ColorFlagSolidLightBackground = "#ffffff";
export const ColorFlagSolidLightBorder = "#ffffff";
export const ColorFlagSolidLightText = "#000000";
export const ColorFlagSolidDangerBackground = "#df382b";
export const ColorFlagSolidDangerBorder = "#df382b";
export const ColorFlagSolidDangerText = "#ffffff";
export const ColorFlagBorderedBackground = "#ffffff";
export const ColorFlagBorderedBorder = "#78be20";
export const ColorFlagBorderedText = "#78be20";
export const ColorFlagBorderedPrimary02Background = "#ffffff";
export const ColorFlagBorderedPrimary02Border = "#035f64";
export const ColorFlagBorderedPrimary02Text = "#035f64";
export const ColorFlagBorderedDarkBackground = "#ffffff";
export const ColorFlagBorderedDarkBorder = "#000000";
export const ColorFlagBorderedDarkText = "#000000";
export const ColorFlagBorderedLightBackground = "#000000";
export const ColorFlagBorderedLightBorder = "#ffffff";
export const ColorFlagBorderedLightText = "#ffffff";
export const ColorFlagBorderedDangerBackground = "#ffffff";
export const ColorFlagBorderedDangerBorder = "#df382b";
export const ColorFlagBorderedDangerText = "#df382b";
export const ColorFocusGap = "#ffffff";
export const ColorFocusBorder = "#25a8d0";
export const ColorFontPrimary01 = "#78be20";
export const ColorFontPrimary02 = "#007574";
export const ColorFontDarkest = "#000000";
export const ColorFontDarker = "#222020";
export const ColorFontDark = "#3c3738";
export const ColorFontLight = "#6f676c";
export const ColorFontLightest = "#ffffff";
export const ColorFontInfo = "#2282a8";
export const ColorFontSuccess = "#41a017";
export const ColorFontWarning = "#c86f21";
export const ColorFontDanger = "#b42a27";
export const ColorInputText = "#222020";
export const ColorInputBorder = "#6f676c";
export const ColorInputPlaceholder = "#887f87";
export const ColorInputBackground = "#ffffff";
export const ColorInputDisabledBorder = "#eeeef0";
export const ColorInputDisabledBackground = "#eeeef0";
export const ColorInputDisabledIcon = "#a19ba2";
export const ColorInputHoverBorder = "#222020";
export const ColorInputFocusBorder = "#25a8d0";
export const ColorInputValidBorder = "#78be20";
export const ColorInputValidHoverBorder = "#0a601b";
export const ColorInputInvalidBorder = "#b42a27";
export const ColorInputInvalidHoverBorder = "#641b21";
export const ColorInputCheckedBorder = "#78be20";
export const ColorInputCheckedBackground = "#78be20";
export const ColorInputCheckedIcon = "#ffffff";
export const ColorInputCheckedHoverBorder = "#0a601b";
export const ColorLinkDarkBase = "#000000";
export const ColorLinkDarkVisited = "#3c3738";
export const ColorLinkDarkActive = "#3c3738";
export const ColorLinkDarkDisabled = "#eeeef0";
export const ColorLinkDarkHover = "#6f676c";
export const ColorLinkLightBase = "#ffffff";
export const ColorLinkLightVisited = "#d3d2d6";
export const ColorLinkLightActive = "#d3d2d6";
export const ColorLinkLightDisabled = "#eeeef0";
export const ColorLinkLightHover = "#a19ba2";
export const ColorLinkPrimaryBase = "#78be20";
export const ColorLinkPrimaryVisited = "#158110";
export const ColorLinkPrimaryActive = "#158110";
export const ColorLinkPrimaryDisabled = "#eeeef0";
export const ColorLinkPrimaryHover = "#053e1f";
export const ColorLinkPrimary02Base = "#035f64";
export const ColorLinkPrimary02Visited = "#044c53";
export const ColorLinkPrimary02Active = "#044c53";
export const ColorLinkPrimary02Disabled = "#eeeef0";
export const ColorLinkPrimary02Hover = "#062b35";
export const ColorLinkDangerBase = "#b42a27";
export const ColorLinkDangerVisited = "#8b2226";
export const ColorLinkDangerActive = "#8b2226";
export const ColorLinkDangerDisabled = "#eeeef0";
export const ColorLinkDangerHover = "#3e1219";
export const ColorNotificationFont = "#000000";
export const ColorNotificationInformationBackground = "#ecfcfd";
export const ColorNotificationInformationBorder = "#25a8d0";
export const ColorNotificationSuccessBackground = "#eaf3e2";
export const ColorNotificationSuccessBorder = "#78be20";
export const ColorNotificationWarningBackground = "#fff5eb";
export const ColorNotificationWarningBorder = "#fc961e";
export const ColorNotificationDangerBackground = "#feedee";
export const ColorNotificationDangerBorder = "#df382b";
export const ColorProgressBackground = "#d3d2d6";
export const ColorProgressIndicator = "#2282a8";
export const ColorProgressPercentageDefault = "#222020";
export const ColorProgressPercentageHalf = "#ffffff";
export const ColorProgressBrandedIndicator = "#78be20";
export const ColorStarEmpty = "#d3d2d6";
export const ColorStarFocus = "#25a8d0";
export const ColorStarFull = "#fc961e";
export const ColorStarHover = "#ffc17d";
export const ColorTabsBackground = "#ffffff";
export const ColorTabsShadow = "#000000";
export const ColorTabsDefault = "#222020";
export const ColorTabsHover = "#41a017";
export const ColorTabsDisabled = "#6f676c";
export const ColorTabsActive = "#78be20";
export const ColorTabsActiveDisabled = "#cbe3b5";
export const ColorTagTextLightBackground = "#ffffff";
export const ColorTagTextLightBorder = "#554f52";
export const ColorTagTextLightText = "#554f52";
export const ColorTagTextDarkBackground = "#000000";
export const ColorTagTextDarkBorder = "#ffffff";
export const ColorTagTextDarkText = "#ffffff";
export const ColorTagLinkLightBackground = "#ffffff";
export const ColorTagLinkLightBorder = "#554f52";
export const ColorTagLinkLightText = "#554f52";
export const ColorTagLinkLightHoverBackground = "#eeeef0";
export const ColorTagLinkLightActiveBackground = "#d3d2d6";
export const ColorTagLinkDarkBackground = "#000000";
export const ColorTagLinkDarkBorder = "#ffffff";
export const ColorTagLinkDarkText = "#ffffff";
export const ColorTagLinkDarkHoverBackground = "#3c3738";
export const ColorTagLinkDarkActiveBackground = "#554f52";
export const ColorTagSelectableLightBackground = "#d3d2d6";
export const ColorTagSelectableLightText = "#222020";
export const ColorTagSelectableLightHoverBackground = "#add585";
export const ColorTagSelectableLightActiveBackground = "#41a017";
export const ColorTagSelectableLightDisabledBackground = "#eeeef0";
export const ColorTagSelectableLightDisabledText = "#887f87";
export const ColorTagSelectableLightSelectedBackground = "#78be20";
export const ColorTagSelectableDarkBackground = "#3c3738";
export const ColorTagSelectableDarkText = "#ffffff";
export const ColorTagSelectableDarkHoverBackground = "#78be20";
export const ColorTagSelectableDarkActiveBackground = "#0a601b";
export const ColorTagSelectableDarkSelectedBackground = "#158110";
export const ColorTagSelectableDarkDisabledBackground = "#554f52";
export const ColorTagSelectableDarkDisabledText = "#887f87";
export const ColorTagRemovableLightBackground = "#d3d2d6";
export const ColorTagRemovableLightText = "#222020";
export const ColorTagRemovableLightIcon = "#3c3738";
export const ColorTagRemovableLightHoverBackground = "#bab6bc";
export const ColorTagRemovableLightActiveBackground = "#a19ba2";
export const ColorTagRemovableDarkBackground = "#3c3738";
export const ColorTagRemovableDarkText = "#ffffff";
export const ColorTagRemovableDarkIcon = "#d3d2d6";
export const ColorTagRemovableDarkHoverBackground = "#554f52";
export const ColorTagRemovableDarkActiveBackground = "#6f676c";
export const ColorToggleOffBackground = "#887f87";
export const ColorToggleOffCircle = "#ffffff";
export const ColorToggleOnBackground = "#78be20";
export const ColorToggleOnCircle = "#ffffff";
export const ColorToggleHoverCircle = "#eeeef0";
export const ColorToggleDisabledBackground = "#eeeef0";
export const ColorToggleDisabledCircle = "#bab6bc";
export const ColorToggleDisabledCheckedBackground = "#cbe3b5";
export const ColorToggleDisabledCheckedCircle = "#ffffff";
export const Preset = "lm";
export const RadiusS = 2;
export const RadiusM = 4;
export const RadiusL = 6;
export const ShadowSX = "0px";
export const ShadowSY = "1px";
export const ShadowSBlur = "5px";
export const ShadowSSpread = "0px";
export const ShadowSOpacity = "0.2";
export const ShadowMX = "0px";
export const ShadowMY = "2px";
export const ShadowMBlur = "10px";
export const ShadowMSpread = "0px";
export const ShadowMOpacity = "0.2";
export const ShadowLX = "0px";
export const ShadowLY = "4px";
export const ShadowLBlur = "20px";
export const ShadowLSpread = "0px";
export const ShadowLOpacity = "0.2";
export const MagicUnit = 1;
export const LocalRemValue = 16;
export const SizeFont10 = "2.5625rem"; // 41px
export const SizeFont11 = "3.0625rem"; // 49px
export const SizeFont12 = "3.6875rem"; // 59px
export const SizeFont01 = "0.6815rem"; // 11px
export const SizeFont02 = "0.75rem"; // 12px
export const SizeFont03 = "0.8125rem"; // 13px
export const SizeFont04 = "0.875rem"; // 14px
export const SizeFont05 = "1rem"; // 16px
export const SizeFont06 = "1.125rem"; // 18px
export const SizeFont07 = "1.4375rem"; // 23px
export const SizeFont08 = "1.75rem"; // 28px
export const SizeFont09 = "2.125rem"; // 34px
export const SizeLine10Xs = "2.5rem"; // 40px
export const SizeLine10S = "3rem"; // 48px
export const SizeLine10M = "3.5rem"; // 56px
export const SizeLine10L = "3.75rem"; // 60px
export const SizeLine11Xs = "3rem"; // 48px
export const SizeLine11S = "3.5rem"; // 56px
export const SizeLine11M = "4.25rem"; // 68px
export const SizeLine11L = "4.5rem"; // 72px
export const SizeLine12Xs = "3.75rem"; // 60px
export const SizeLine12S = "4.25rem"; // 68px
export const SizeLine12M = "5rem"; // 80px
export const SizeLine12L = "5.5rem"; // 88px
export const SizeLine01Xs = "0.75rem"; // 12px
export const SizeLine01S = "0.75rem"; // 12px
export const SizeLine01M = "0.875rem"; // 14px
export const SizeLine01L = "1rem"; // 16px
export const SizeLine02Xs = "0.75rem"; // 12px
export const SizeLine02S = "0.875rem"; // 14px
export const SizeLine02M = "1rem"; // 16px
export const SizeLine02L = "1.125rem"; // 18px
export const SizeLine03Xs = "0.875rem"; // 14px
export const SizeLine03S = "1rem"; // 16px
export const SizeLine03M = "1.125rem"; // 18px
export const SizeLine03L = "1.25rem"; // 20px
export const SizeLine04Xs = "0.875rem"; // 14px
export const SizeLine04S = "1rem"; // 16px
export const SizeLine04M = "1.125rem"; // 18px
export const SizeLine04L = "1.375rem"; // 22px
export const SizeLine05Xs = "1rem"; // 16px
export const SizeLine05S = "1.125rem"; // 18px
export const SizeLine05M = "1.375rem"; // 22px
export const SizeLine05L = "1.5rem"; // 24px
export const SizeLine06Xs = "1.125rem"; // 18px
export const SizeLine06S = "1.25rem"; // 20px
export const SizeLine06M = "1.5rem"; // 24px
export const SizeLine06L = "1.75rem"; // 28px
export const SizeLine07Xs = "1.5rem"; // 24px
export const SizeLine07S = "1.75rem"; // 28px
export const SizeLine07M = "2rem"; // 32px
export const SizeLine07L = "2.25rem"; // 36px
export const SizeLine08Xs = "1.75rem"; // 28px
export const SizeLine08S = "2rem"; // 32px
export const SizeLine08M = "2.25rem"; // 36px
export const SizeLine08L = "2.75rem"; // 44px
export const SizeLine09Xs = "2.25rem"; // 36px
export const SizeLine09S = "2.5rem"; // 40px
export const SizeLine09M = "2.75rem"; // 44px
export const SizeLine09L = "3.25rem"; // 52px
export const SizeGutterScreenS = "1rem";
export const SizeGutterScreenM = "2rem";
export const ScreenS = "0px";
export const ScreenSMedium = "320px";
export const ScreenSLarge = "360px";
export const ScreenSXlarge = "390px";
export const ScreenM = "680px";
export const ScreenMMedium = "769px";
export const ScreenL = "1024px";
export const ScreenLMedium = "1100px";
export const ScreenXl = "1280px";
export const ScreenXlMedium = "1440px";
export const ScreenXlLarge = "1680px";
export const ScreenXxl = "1920px";